// webview updateHeader
export const HeaderMap = {
  PERSONALBOOK: { type: 2, title: '角色設定' },
  COVER: { type: 4, title: '封面選擇' },
  BACKGROUND: { type: 4, title: '想說的話', keyboard: 1 },
  PREVIEW: { type: 4, title: '預覽童書' }
} as const
